import { Component } from "@angular/core";
import {
  Platform,
  NavParams,
  ViewController,
  ModalController,
  AlertController
} from "ionic-angular";
import { SummaryServiceProvider } from "../../../../providers/wh/summary-service";

@Component({
  selector: "edit-cp-national-address-info-modal",
  templateUrl: "edit-cp-national-address-info-modal.html",
  providers: [SummaryServiceProvider]
})
export class ChangeNationalAddressInfoCpModalComponent {
  text: string;
  data;
  preData;
  codSupport;
  cpName;
  filterData: any;
  requestFields: any = {};
  categoryFilterList: any;
  myInput: any;
  parkingRemarksArray = [
    {
      id: "Parking Available",
      value: "Yes"
    },
    {
      id: "Parking Not Available",
      value: "No"
    }
  ];

  constructor(
    public platform: Platform,
    public params: NavParams,
    public alertCtrl: AlertController,
    public summaryService: SummaryServiceProvider,
    public modalCtrl: ModalController,
    public viewCtrl: ViewController
  ) {
    this.text = "Hello World";
    this.data = this.params.get("data");
    // this.preData = { ...this.data, areaEntity: this.data.areaEntity };
    if (!this.data.newCategoryEntity) {
      this.data.newCategoryEntity = { id: 11, value: "Unknown" };
    }
    this.preData = JSON.parse(JSON.stringify(this.data));
    console.log("this.data", this.data);
    console.log("this.preData", this.preData);
    this.cpName = this.data.name;
    this.filterData = JSON.parse(localStorage.getItem("fuFilters"));
  }

  compareFn(a, b) {
    return a && b ? a === b : a === b;
  }

  saveBasicInfo(id) {
    var payload: any = {};
    var nationalAddressObj: any = {
      amazon: {
        address1: this.data.nationalAddress.amazon.address1,
        address2: this.data.nationalAddress.amazon.address2,
        address3: this.data.nationalAddress.amazon.address3
      }
    };
    payload.nationalAddress = JSON.stringify(nationalAddressObj);
    // }

    if (!this.isObjectEmpty(payload)) {
      this.summaryService.patchCPInfo(id, payload).then(res => {
        this.viewCtrl.dismiss(true);
      });
    } else {
      this.viewCtrl.dismiss(true);
    }
  }



  isObjectEmpty(Obj) {
    for (var key in Obj) {
      if (Obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  dismiss() {
    this.viewCtrl.dismiss(true);
  }
}



// WEBPACK FOOTER //
// ./src/pages/backoffice/collecion-points/edit-cp-national-address-info/edit-cp-national-address-info-modal.ts